(function () {
    'use strict';

    angular.module("imApp").factory("orderlineStatusService", ['$ihttp', function ($ihttp) {
        let service = {
            listStatuses: function (parms) {
                return $ihttp.post({
                    method: 406,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
